var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * 拦截器
 */
import { createRequestError, ErrorType, isRequestError, isAxiosError } from '@tencent/vb-web-base-core';
import { doSignQueryBody } from './utils/sign';
import { setServerTimeDiff } from './utils/helper';
/**
 * 业务异常
 */
export var businessError = [
    function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, code, message, busError;
        return __generator(this, function (_b) {
            if (response.data) {
                _a = response.data, code = _a.code, message = _a.message;
                // 0 业务逻辑上请求成功
                if (code !== 0) {
                    busError = createRequestError(message, ErrorType.BUSINESS, response.config, { code: code });
                    throw busError;
                }
            }
            return [2 /*return*/, response];
        });
    }); },
    function (error) {
        return Promise.reject(error);
    },
];
/**
 * 异常处理拦截器
 */
export var errorHandler = [
    function (response) {
        return response;
    },
    function (error) {
        var _a;
        if (isRequestError(error)) {
            return Promise.reject(error);
        }
        // 这里把axios抛出的所有异常都当做网络异常，对不对？
        // axios抛出的异常有：1. 请求中断 2. 网络应用层（502等）异常 3. 网络层异常
        // 4. 超时 5. E_JSON_PARSE(stack会丢失)
        // 其中 1 2 3 4 都归结于http异常类型，5归结于JSON_PARSE异常
        if (isAxiosError(error)) {
            // http error中 的http status 作为异常的code属性
            // 是axios异常，且为http status 异常，则将status code 赋值给code
            var axiosCode = error.code;
            if (axiosCode === 'E_JSON_PARSE') {
                return Promise.reject(createRequestError(error.message, ErrorType.JSON_PARSE, error.config, {
                    source: error,
                }));
            }
            var code = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
            return Promise.reject(createRequestError(error.message, ErrorType.HTTP, error.config, { code: code, source: error }));
        }
        // 其他情况
        return Promise.reject(createRequestError(error.message, ErrorType.OTHER, error.config, { source: error }));
    },
];
/**
 * 解构data中的data
 * vb中返回的需要关注的数据，在返回数据中的data字段，这里做一层解构
 */
export var destructionData = [
    function (response) {
        var _a;
        if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) {
            response.data = response.data.data;
        }
        return response;
    },
    function (error) {
        return Promise.reject(error);
    },
];
export var sign = [
    function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var paramsKeyVals, queryStartIndex, paramsKeyValStr, queryStr, queStartIndex, bodyStr, signInfo, reqUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // jsCookie.set('signkeyseq', '1');
                    // jsCookie.set('x-vb-channel', 'web');
                    // 把入参的params对象转为字符串添加到url上（axios组件会做，但这里需要提前做，否则不好计算签名）
                    if (config.params && typeof config.params !== 'string') {
                        paramsKeyVals = Object.keys(config.params).map(function (itemKey) {
                            if (config.params[itemKey] !== undefined) {
                                return "".concat(itemKey, "=").concat(config.params[itemKey]);
                            }
                        });
                        queryStartIndex = config.url.indexOf('?');
                        paramsKeyValStr = paramsKeyVals.join('&');
                        if (queryStartIndex >= 0) {
                            if (paramsKeyValStr) {
                                config.url = "".concat(config.url, "&").concat(paramsKeyValStr);
                            }
                        }
                        else {
                            if (paramsKeyValStr) {
                                config.url = "".concat(config.url, "?").concat(paramsKeyValStr);
                            }
                        }
                        config.params = undefined;
                    }
                    queryStr = '';
                    queStartIndex = config.url.indexOf('?');
                    bodyStr = config.data ? JSON.stringify(config.data) : '';
                    if (!(queStartIndex >= 0)) return [3 /*break*/, 2];
                    reqUrl = config.url.substr(0, queStartIndex);
                    queryStr = config.url.substring(queStartIndex + 1);
                    return [4 /*yield*/, doSignQueryBody(queryStr, bodyStr)];
                case 1:
                    signInfo = _a.sent();
                    config.url = "".concat(reqUrl, "?").concat(signInfo.queryString);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, doSignQueryBody('', bodyStr)];
                case 3:
                    signInfo = _a.sent();
                    config.url = "".concat(config.url, "?").concat(signInfo.queryString);
                    _a.label = 4;
                case 4:
                    // TWS 接口的 response headers 会返回 Content-Type: text/html; charset=gb2312
                    // 但是实际的 response data 却是 utf8 编码
                    // 解决这个问题的方法:
                    // 1. 构建 axios 请求的时候, 指定 responseType = 'arraybuffer'(告诉 axios 不要自动解码)
                    // 2. 获得二进制响应后, 强行使用 utf8 解码 (无视 charset)
                    if (config.responseType === undefined && /^\/tws/.test(config.url || '')) {
                        config.responseType = 'arraybuffer';
                    }
                    return [2 /*return*/, config];
            }
        });
    }); },
    function (error) {
        Promise.reject(error);
    },
];
export var decodeResponse = [
    function (response) {
        // TWS 接口的 response headers 会返回 Content-Type: text/html; charset=gb2312
        // 但是实际的 response data 却是 utf8 编码
        // 解决这个问题的方法:
        // 1. 构建 axios 请求的时候, 指定 responseType = 'arraybuffer'(告诉 axios 不要自动解码)
        // 2. 获得二进制响应后, 强行使用 utf8 解码 (无视 charset)
        if (response.config.responseType === 'arraybuffer' && /^\/tws/.test(response.config.url || '')) {
            var str = new TextDecoder('utf8').decode(response.data);
            var json = JSON.parse(str);
            response.data = json;
        }
        // 设置但前本地时间与服务器时间的差值，主要用户计算服务器时间
        setServerTimeDiff(response.data);
        return response;
    },
    function (error) {
        return Promise.reject(error);
    },
];
